// Dynamically classify presets returned by GET /presets into camera movements
// vs special effects. Based ONLY on returned metadata — no invented options.
//
// Current reality of the public API: it returns special-effect / staging / text
// presets and NO pure camera-movement presets (orbit, forward, backward, pan).
// This classifier stays keyword-based so that IF the API later adds real movement
// presets, they surface automatically in the Camera Movements tab.

const MOVEMENT_KEYWORDS = [
  "orbit",
  "dolly",
  "truck",
  "pedestal",
  "crane",
  "tilt",
  "pan left",
  "pan right",
  "push in",
  "pull out",
  "camera movement",
  "camerabeweging",
];

// The synthetic "automatic camera movement" option: omit presetKey entirely so the
// provider applies its documented default behaviour.
export const AUTO_MOVEMENT = {
  key: "__AUTO__",
  name: "Automatische camerabeweging",
  description: "Laat de studio automatisch de best passende camerabeweging kiezen (standaard).",
  auto: true,
};

function isMovement(preset) {
  const hay = `${preset.key || ""} ${preset.name || ""}`.toLowerCase();
  return MOVEMENT_KEYWORDS.some((kw) => hay.includes(kw));
}

export function classifyPresets(presets = []) {
  const sorted = [...presets].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  const movements = sorted.filter(isMovement);
  const effects = sorted.filter((p) => !isMovement(p));
  return { movements, effects };
}

// Resolve a stored selection value to a label for summaries.
export function presetLabel(presetKey, presets) {
  if (!presetKey) return AUTO_MOVEMENT.name;
  const found = presets.find((p) => p.key === presetKey);
  return found?.name || presetKey;
}
